import React from 'react'
import * as styles from './container.module.css'

export default ({ children }) => (
  <div className={styles.page}>{children}</div>
)
